import React from 'react'
import { icons } from '../utilits/icons'
import { optionElips, optionElips3 } from '../utilits/statisticTools'
import Chart from 'react-apexcharts'

export default function Fluid() {
  return (
    <div className='range'>
      <span>{icons.break}</span>
      <h3>Break fluid</h3>
      <Chart options={optionElips3.options} series={optionElips3.series} type="radialBar" />
    </div>
  )
}
